import { useEffect } from "react";
import { HubConnectionState } from "@microsoft/signalr";

import { useSignalRContext } from "../../Contexts/SignalRContext";
import { MachinePositionsMapView } from "../../Map/MachinePositionsMapView";
import { LiveIndicatorState } from "../DashboardCard";

type MachinePositionsCardProps = {
  onLiveIndicatorChange?: (state: LiveIndicatorState) => void;
};

export const MachinePositionsCard: React.FC<MachinePositionsCardProps> = ({ onLiveIndicatorChange }) => {
  const { connection } = useSignalRContext();
  const isLive = connection?.state === HubConnectionState.Connected;

  useEffect(() => {
    onLiveIndicatorChange?.({
      active: isLive,
      showLabel: isLive,
      tooltipText: isLive ? "Receiving live position updates" : "Live updates unavailable",
    });
  }, [isLive, onLiveIndicatorChange]);

  return (
    <div className="w-full h-full min-h-0 flex flex-col gap-3 p-3">
      <MachinePositionsMapView sitePlanOption={false} />
    </div>
  );
};
